import alerts from './components/alerts.json';
import continueWatchingTile from './components/continueWatchingTile.json';
import currentWeatherConditionsTile from './components/currentWeatherConditionsTile.json';
import dailyDayForecastTile from './components/dailyDayForecastTile.json';
import dailyWeatherConditionsTile from './components/dailyWeatherConditionsTile.json';
import dailyWeatherForecastDaypart from './components/dailyWeatherForecastDaypart.json';
import hourlyHourForecastTile from './components/hourlyHourForecastTile.json';
import hourlyWeatherForecastTile from './components/hourlyWeatherForecastTile.json';
import liveVideoTile from './components/liveVideoTile.json';
import locations from './components/locations.json';
import longFormItemTile from './components/longFormItemTile.json';
import lowerDisplayLine from './components/lowerDisplayLine.json';
import pipWidget from './components/pipWidget.json';
import shortFormItemTile from './components/shortFormItemTile.json';
import showDetailPageHeader from './components/showDetailPageHeader.json';
import timeUtil from './components/timeUtil.json';
import videoControls from './components/videoControls.json';
import videoPlayer from './components/videoPlayer.json';
import authVerificationPage from './authVerificationPage.json';
import currentWeatherConditionsPage from './currentWeatherConditionsPage.json';
import dailyWeatherPage from './dailyWeatherPage.json';
import deviceActivationPage from './deviceActivationPage.json';
import dvrPage from './dvrPage.json';
import errorOnboardingPage from './errorOnboardingPage.json';
import errors from './errors.json';
import hourlyWeatherPage from './hourlyWeatherPage.json';
import livePage from './livePage.json';
import loadingPage from './loadingPage.json';
import mainMenu from './mainMenu.json';
import map from './map.json';
import myWeatherPage from './myWeatherPage.json';
import onboardingFreeTrialPage from './onboardingFreeTrialPage.json';
import onDemandPage from './onDemandPage.json';
import pictureDetailedPage from './pictureDetailedPage.json';
import searchPage from './searchPage.json';
import settingsPage from './settingsPage.json';
import subscriberSignInPage from './subscriberSignInPage.json';
import subscriberSignUpPage from './subscriberSignUpPage.json';
import subscriptionSelectionPage from './subscriptionSelectionPage.json';
import successPage from './successPage.json';
import twc from './twc.json';
import welcomeBackPage from './welcomeBackPage.json';

export const en = {
  translation: {
    showDetailPageHeader,
    dailyDayForecastTile,
    dailyWeatherPage,
    currentWeatherConditionsPage,
    currentWeatherConditionsTile,
    dailyWeatherConditionsTile,
    dailyWeatherForecastDaypart,
    dvrPage,
    errors,
    hourlyHourForecastTile,
    hourlyWeatherForecastTile,
    hourlyWeatherPage,
    livePage,
    liveVideoTile,
    loadingPage,
    lowerDisplayLine,
    pipWidget,
    mainMenu,
    map,
    myWeatherPage,
    onDemandPage,
    onboardingFreeTrialPage,
    deviceActivationPage,
    searchPage,
    timeUtil,
    locations,
    videoControls,
    videoPlayer,
    settingsPage,
    alerts,
    authVerificationPage,
    successPage,
    subscriptionSelectionPage,
    subscriberSignUpPage,
    subscriberSignInPage,
    errorOnboardingPage,
    welcomeBackPage,
    shortFormItemTile,
    longFormItemTile,
    continueWatchingTile,
    pictureDetailedPage,
    twc,
  },
};
